import { useMutation } from "@tanstack/react-query";
import { rmResvCnlInfApi, rmResvCnlsApi } from "components/api/rm";
import { PAGE_ID_ROOM_RESV_CANCEL } from "components/constent";
import { apifield } from "components/utils/comm";
import { dateFormat, pageInitInf, priceFormat } from "components/utils/comm";
import { IPageNav } from "interface/index";
import { IRmResvCnlInf, IRmResvCnls } from "interface/rm/rsvCnl";
import { useEffect, useRef, useState } from "react";
import useListRowInfStroe from "store/listRowInf";
import usePageNoStore from "store/pageNo";
import { useResvCancelParamContext } from "./context";
import { initialPageNav } from "components/utils/comm";

// 객실 예약취소 조회

export const useSearchList = () => {
  const { param } = useResvCancelParamContext();

  const [rowData, setRowData] = useState<any[] | null>(null);
  const pageNavRef = useRef<IPageNav>(initialPageNav);

  const mutation = useMutation({
    mutationKey: ["room-cancel-resv-search"],
    mutationFn: rmResvCnlsApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          const pageNav = data.pageNav;
          pageNavRef.current = data.pageNav;
          const rmResvCnls = data.rmResvCnlList.map(
            (cnl: IRmResvCnls, index: number) => {
              return {
                ...cnl,
                No: (pageNav.pageNo - 1) * pageNav.pageRows + index + 1,
                resvDtti: dateFormat(cnl.resvDtti.slice(0, 8), "-"),
                cnlDtti: dateFormat(cnl.cnlDtti.slice(0, 8), "-"),
                resvCstNm: cnl.resvCstSurnm + cnl.resvCstFstnm,
                sellCnlPri:
                  priceFormat({ price: cnl.rmSellPri }) +
                  "/" +
                  priceFormat({ price: cnl.cnlFeeAmt }),
              };
            }
          );
          setRowData(rmResvCnls);
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });

  useEffect(() => {
    if (param) {
      mutation.mutate({
        ...param,
        ...pageInitInf,
      });
    }
  }, [param]);

  // NextPage
  const pageNo = usePageNoStore((state) => state.pageNo);
  const isCurrent = pageNo?.target === PAGE_ID_ROOM_RESV_CANCEL;

  useEffect(() => {
    if (isCurrent) {
      const params = {
        ...param,
        pageNo: pageNo?.no || 1,
        pageRows: pageNo?.pageRows,
      };

      mutation.mutate({
        ...params,
        pageNo: pageNo?.no || 1,
        pageRows: pageNo?.pageRows,
      });
    }
  }, [pageNo?.no, pageNo?.pageRows]);

  return {
    rowData,
    pageNav: pageNavRef.current,
  };
};

// 예약취소 상세
export const useGetData = () => {
  const listRowInf = useListRowInfStroe((state) => state.listRowInf);
  const rmResvCnlDtlRef = useRef<IRmResvCnlInf | null>(null);

  const params = {
    rmNo: listRowInf.no,
    ...listRowInf.param,
  };

  const mutation = useMutation({
    mutationKey: ["room-cancel-resv-detail"],
    mutationFn: rmResvCnlInfApi,
    onSuccess(res) {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          rmResvCnlDtlRef.current = res.data.rmResvCnlDtl;
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });

  useEffect(() => {
    if (params.rmResvNo) {
      mutation.mutate(params);
    }
  }, [params.rmResvNo]);

  return {
    rmResvCnlDtl: rmResvCnlDtlRef.current,
    isLoading: mutation.isPending,
    isSuccess: mutation.isSuccess,
  };
};
